// extracted by mini-css-extract-plugin
export var chevron = "_il-3";
export var chevronRotated = "_il-4";
export var image = "_il-1";
export var imageContainer = "_il-0";
export var shippingAddress = "_il-2";